@if (isLoading) {
  <div class="rank-loading">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div class="rank-container">
    <div class="main-box views">
      <div class="view-count">{{views ?? 0}}</div>
      <div class="view-title">VIEWS</div>
    </div>
    <div class="main-box gauge">
      <img src="/assets/images/rank/gauge.png" id="gauge-image" />
      <img src="/assets/images/rank/needle.png" class="gauge-pointer" [style.transform]="needleTransform" />
    </div>
    <div class="main-box titles">
      @if (currentRank === 'Guru') {
        <img
          src="/assets/images/guru_badge.png"
          alt="SalesMail Guru badge"
          class="guru-badge"
          (click)="openGuruDialog()"
          />
      }
      @for (panel of rankPanels; track panel) {
        <img
          src="{{panel.rank == currentRank ? panel.onImage : panel.offImage}}"
          class="rank-image {{  panel.rank == currentRank ? 'grow-shake-animation rank-image-on' : 'grow-animation' }}"
          />
      }
    </div>
  </div>
}
